import { createContext, type PropsWithChildren, useContext } from 'react';

import type { RentalOnboardingStep } from '../features/onboarding/onboardingUtils';

type OnboardingTourContextType = {
    showRentalOnboardingTour: boolean;
    setShowRentalOnboardingTour: (show: boolean) => void;
    activeStep: RentalOnboardingStep | null;
    setActiveStep: (step: RentalOnboardingStep | null) => void;
};

export const OnboardingTourContext = createContext<OnboardingTourContextType>(
    {} as unknown as OnboardingTourContextType
);
export const useOnboardingTourContext = () => useContext(OnboardingTourContext);

const OnboardingTourContextProvider = ({
    showRentalOnboardingTour,
    setShowRentalOnboardingTour,
    activeStep,
    setActiveStep,
    children,
}: PropsWithChildren<OnboardingTourContextType>) => (
    <OnboardingTourContext.Provider
        value={{ showRentalOnboardingTour, setShowRentalOnboardingTour, activeStep, setActiveStep }}
    >
        {children}
    </OnboardingTourContext.Provider>
);

export default OnboardingTourContextProvider;
